import {
  //
  TEMPLATE_INDIVIDUAL_START_LISTING,
  TEMPLATE_INDIVIDUAL_SET_LISTING,
  TEMPLATE_INDIVIDUAL_SET_LISTING_ERROR,
  //
  TEMPLATE_START_LISTING,
  TEMPLATE_SET_LISTING,
  TEMPLATE_SET_LISTING_ERROR,
  //
  TEMPLATE_ADD_SUBMIT,
  TEMPLATE_ADD_SUCCESS,
  TEMPLATE_ADD_FAILURE,
  //
  TEMPLATE_SAVE_SUCCESS,
  TEMPLATE_SAVE_FAILURE,
  //
  TEMPLATE_GET_FILTER_DATA,
  TEMPLATE_GET_FILTER_DATA_SUCCESS,
  TEMPLATE_GET_FILTER_DATA_FAILURE,
  //
  TEMPLATE_SET_EDIT_TEMPLATE,
  TEMPLATE_EDIT_SUBMIT,
  TEMPLATE_EDIT_SUCCESS,
  TEMPLATE_EDIT_FAILURE,
} from "./constants";

// INDIVIDUAL TEMPLATE
export const getIndividualTemplateListing = (payload) => ({
  type: TEMPLATE_INDIVIDUAL_START_LISTING,
  payload,
});
export const setIndividualTemplateListing = (payload) => ({
  type: TEMPLATE_INDIVIDUAL_SET_LISTING,
  payload,
});
export const setIndividualTemplateListingeError = (payload) => ({
  type: TEMPLATE_INDIVIDUAL_SET_LISTING_ERROR,
  payload,
});

// ALL TEMPLATES
export const getTemplateListing = (payload) => ({
  type: TEMPLATE_START_LISTING,
  payload,
});
export const setTemplateListing = (payload) => ({
  type: TEMPLATE_SET_LISTING,
  payload,
});
export const setTemplateError = (payload) => ({
  type: TEMPLATE_SET_LISTING_ERROR,
  payload,
});

// ADD TEMPLATES
export const submitTemplateAdd = (payload) => ({
  type: TEMPLATE_ADD_SUBMIT,
  payload,
});
export const addTemplateSuccess = (payload) => ({
  type: TEMPLATE_ADD_SUCCESS,
  payload,
});
export const addTemplateFailure = (payload) => ({
  type: TEMPLATE_ADD_FAILURE,
  payload,
});

//EDIT TEMPLATE
export const setEditTemplate = (payload) => ({
  type: TEMPLATE_SET_EDIT_TEMPLATE,
  payload,
});
export const submitTemplateEdit = (payload) => ({
  type: TEMPLATE_EDIT_SUBMIT,
  payload,
});
export const editTemplateSuccess = (payload) => ({
  type: TEMPLATE_EDIT_SUCCESS,
  payload,
});
export const editTemplateFailure = (payload) => ({
  type: TEMPLATE_EDIT_FAILURE,
  payload,
});

// SAVE TEMPLATE
export const saveTemplateSuccess = (payload) => ({
  type: TEMPLATE_SAVE_SUCCESS,
  payload,
});
export const saveTemplateFailure = (payload) => ({
  type: TEMPLATE_SAVE_FAILURE,
  payload,
});

//FILTER TEMPLATE
export const getFilterData = (payload) => ({
  type: TEMPLATE_GET_FILTER_DATA,
  payload,
});
export const getFilterDataSuccess = (payload) => ({
  type: TEMPLATE_GET_FILTER_DATA_SUCCESS,
  payload,
});
export const getFilterDataFailure = (payload) => ({
  type: TEMPLATE_GET_FILTER_DATA_FAILURE,
  payload,
});
